"use strict";

exports.__esModule = true;
exports.getUserIcon = getUserIcon;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserIcon() {
  return _react.default.createElement("svg", {
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    version: "1.1"
  }, _react.default.createElement("path", {
    d: "M46,17 L18,17 C15.78,17 14.02,18.8 14.02,21 L14,49 C14,51.2 15.78,53 18,53 L46,53 C48.2,53 50,51.2 50,49 L50,21 C50,18.8 48.2,17 46,17 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), _react.default.createElement("path", {
    d: "M46,14 L18,14 C15.78,14 14.02,15.8 14.02,18 L14,46 C14,48.2 15.78,50 18,50 L46,50 C48.2,50 50,48.2 50,46 L50,18 C50,15.8 48.2,14 46,14 Z",
    id: "Path",
    fill: "#F2F2F2"
  }));
}

var _default = getUserIcon;
exports.default = _default;